import { actions } from 'react-table';
export default function tableStateReducer(newState, action, prevState, options = {}) {
  if (action.type === actions.columnDoneResizing) {
    const {
      overrides,
      dataViewerId
    } = options;
    const {
      columnResizing: {
        columnWidths
      }
    } = newState;
    Object.entries(columnWidths).forEach(([columnId, width]) => {
      const ovrWidthKey = `table.colWidth.${columnId}`;

      // Do this in a timeout to avoid an error setting state in a render
      setTimeout(() => {
        overrides.set(dataViewerId, ovrWidthKey, width);
      }, 1);
    });
  }
  return newState;
}